import { RecordingsActionType } from 'actions/recordingsActions';
import { RecordingRequestObjectSort, RecordingRequestObjectTimeLine, } from 'constants/recordingsConstants';
import { Reducer } from 'redux';
import RecordingState from 'state/Recordings';

const recordingsReducer: Reducer<RecordingState> =
  (state = new RecordingState(), action) => {
    switch (action.type) {
      case RecordingsActionType.RECORDINGS_SORT_CHANGE:
        return state.set('sortBy', action.payload);
      case RecordingsActionType.RECORDINGS_FILTER_CHANGE:
        return state.set('timeline', action.payload);
      case RecordingsActionType.RECORDINGS_LAYOUT_CHANGE:
        return state.set('isGridLayout', !!action.payload);
      case RecordingsActionType.RECORDINGS_PAGE_CHANGE:
        return state.set('pageNum', action.payload);
      case RecordingsActionType.RECORDINGS_RESET_RECORDING_PROPS:
        return state
          .set('isFetching', false)
          .set('isGridLayout', true)
          .set('pageNum', 1)
          .set('recordingData', null)
          .set('searchResults', [])
          .set('sortBy', RecordingRequestObjectSort.SORT_DATE)
          .set('timeline', RecordingRequestObjectTimeLine.TIMELINE_ANY)
          .set('pending', false);
      case RecordingsActionType.RECORDINGS_CLEAR_SEARCH_RESULTS:
        return state
          .set('searchResults', []);
      case RecordingsActionType.RECORDINGS_PENDING_RESULTS:
        return state
          .set('pending', true);
      case RecordingsActionType.RECORDINGS_SEARCH_ID:
        return state
          .set('meeting', action.payload);
      case RecordingsActionType.RECORDINGS_SEARCH_NAME:
        return state
          .set('meetingName', action.payload);
      case 'VIDEO_GET_CLOUD_MEETINGS_SUCCESS':
        return state
          .set('searchResults', action.payload)
          .set('pending', false);
      case RecordingsActionType.RECORDINGS_ADD_PROCESSING_UPLOAD:
        return state
          .set('uploadsStatus', [...state.uploadsStatus, action.payload]);
      case RecordingsActionType.RECORDINGS_SET_UPLOADS_STATUS:
        return state
          .set('uploadsStatus', action.payload);
      default:
        return state;
    }
  };

export default recordingsReducer;
